<template>
    <v-card>
        <v-card-title>
        <span class="headline">Discount/Loading Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newDiscLdg">
                <v-text-field :label="labels.discLdg" v-model="discLdgForm.discLdg" :error-messages="errors.collect('discLdg')" data-vv-name="discLdg" :data-vv-as="labels.discLdg" v-validate="'required|param|max:2'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.discLdg}}</v-subheader>
                <div class="title">{{discLdgForm.discLdg}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="discLdgForm.discLdgDesc" :label="labels.discLdgDesc" :error-messages="errors.collect('discLdgDesc')" v-validate="'required|entry|max:35'" data-vv-name="discLdgDesc" :data-vv-as="labels.discLdgDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'discLdgForm': Object,
    'newDiscLdg': Boolean
  },
  data() {
    return {
      labels: {
        discLdg: 'Discount/Loading Code*',
        discLdgDesc: 'Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.discLdgForm.discLdg = undefined
      this.discLdgForm.discLdgDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newDiscLdg) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.travel.menu.createDiscLdg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.discLdgForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.travel.menu.updateDiscLdg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.discLdgForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
